// @core/api/endpoints/task/delete_task_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/task';

/**
 * Delete task policy
 * Deletes a task policy. Scope entities will fall through to the next ancestor policy.
 */
export async function DeleteTaskPolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
